/***** Automatic Population of Carousels *****/
ht.declare('.carousel.carouselSlideTarget', function () {
  ht.populateCarousels();
});
ht.declare('.carouselSlideContainer[data-carousel-target] .item', function () {
  ht.populateCarousels();
});
/***** End of Carousel Logic *****/
